import Hero from "./components/Hero";
import CategorySection from "./components/CategorySection";
import FeaturedSection from "./components/FeaturedSection";
import RankingSection from "./components/RankingSection";
import CoverageSection from "./components/CoverageSection";
import FaqSection from "./components/FaqSection";
import JsonLd from "@/components/base/JsonLd";

const site = "https://ymdbo14.cn";

const faqData = [
  {
    q: "漫画网收录了哪些类型的漫画？",
    a: "漫画网收录漫画大全，涵盖热血、恋爱、悬疑、奇幻、科幻、搞笑六大类漫画网漫画分类，并配有完整的漫画网漫画库与漫画网漫画目录。",
  },
  {
    q: "如何在漫画网快速找到想看的漫画？",
    a: "进入漫画大全后，通过漫画网漫画分类切换不同题材，也可按人气排行榜查看热门漫画，每部漫画都有清晰的章节目录。",
  },
  {
    q: "漫画网上的漫画可以免费阅读吗？",
    a: "收录的漫画均可直接进入列表在线阅读，所有内容版权归原作者所有，仅供阅读交流使用。",
  },
];

export default function Home() {
  return (
    <>
      <JsonLd
        data={{
          "@context": "https://schema.org",
          "@type": "WebPage",
          name: "漫画网 - 漫画网漫画大全、漫画网收录漫画",
          url: `${site}/`,
          inLanguage: "zh-CN",
          description: "漫画网首页直达漫画网收录漫画大全，按漫画网漫画库、漫画网漫画分类、漫画网漫画目录快速定位。",
        }}
      />
      <JsonLd
        data={{
          "@context": "https://schema.org",
          "@type": "FAQPage",
          mainEntity: faqData.map((f) => ({
            "@type": "Question",
            name: f.q,
            acceptedAnswer: { "@type": "Answer", text: f.a },
          })),
        }}
      />
      <JsonLd
        data={{
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          itemListElement: [{ "@type": "ListItem", position: 1, name: "首页", item: `${site}/` }],
        }}
      />

      <Hero />
      <CategorySection />
      <FeaturedSection />
      <RankingSection />
      <CoverageSection />
      <FaqSection />
    </>
  );
}